(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AppController
* @description
* This is main controller
* 28
* 30
**/ 

    angular
    .module('app')
    .controller('AppController', AppController);

    AppController.$inject = [
        "$rootScope",
        "debugService",
        "autorService",
        "$location",
        "userService",
        "espaiService",
        "mapsService",
        "rutaService",
        "$timeout",
        '$window',
        "mobileService",
        "$scope",
        "cfpLoadingBar",
        "modalService",
        "$routeParams"

        ];

    function AppController($rootScope,debugService,autorService,$location,userService,espaiService,mapsService,rutaService,$timeout,$window,mobileService,$scope,cfpLoadingBar,modalService,$routeParams)
    {

    	var vm = this;
        vm.modal = modalService;
        vm.autors = [];
        vm.mobile = mobileService;
        vm.autor = autorService;
        vm.user = userService;
        vm.espais = espaiService;
        vm.espais.experiencies = true;
        vm.llistatAutors = false;
        vm.llistatCentres = false;
        vm.llistatRutes = false;
        vm.ruta = rutaService;
        vm.mapa = mapsService;
        $scope.mapa = mapsService;
        mapsService.benvinguts = true;
        vm.orderAutor = 'data.cognom_slug';
        vm.fullScreen = false;
        vm.language = language;


        vm.changeLang = function(lang)
        {
            $window.location.href = "/"+lang;
        };

        vm.changeFullScreen =function(res){
            vm.fullScreen = res;
        };

        
        userService.user();


        vm.letter='a';



        vm.firstItem = function(input)
        {
            if(!input)
                return "";
            var slug = input.toLowerCase().trim();
            slug = slug.replace(/á/gi,"a");
            slug = slug.replace(/é/gi,"e");
            slug = slug.replace(/í/gi,"i");
            slug = slug.replace(/ó/gi,"o");
            slug = slug.replace(/ú/gi,"u");
            slug = slug.replace(/ñ/gi,"n");
            slug = slug.replace(/à/gi,"a");
            slug = slug.replace(/è/gi,"e");
            slug = slug.replace(/ì/gi,"i");
            slug = slug.replace(/ò/gi,"o");
            slug = slug.replace(/ù/gi,"u");
            // replace invalid chars with spaces
            slug = slug.replace(/[^a-z0-9\s-]/g, '');
 
            // replace multiple spaces or hyphens with a single hyphen
            slug = slug.replace(/[\s-]+/g, '-');
 
            return slug[0];
        };
       
        vm.print = function()
        {

                $timeout($window.print, 1000);
        };

        vm.favorit = function (espai,ruta,autor,centre)
        {
            var customer = vm.user.info.pk;
            vm.user.user_fav(customer,espai,ruta,autor,centre);
        };

        vm.autor.scrollToAutor = function(aName)
        {
            console.log("SCROLL TO "+aName);
            
            for (var i = 0; i < jQuery('.autor').length; i++) {
                var nom ='';
                //var nom = jQuery('.autor').eq(i).find('.info').find('.nombre').text().trim();
                nom = jQuery('.autor').eq(i).attr('data-slug');
                //cognom_slug
                if(nom == aName)
                {
                    jQuery('.autores').scrollTop(0);
                    jQuery('.autores').scrollTop(jQuery('.autor').eq(i).offset().top-jQuery('.autores').offset().top);
                    break;
                }
            }
        };

        vm.scrollToLetter = function(letter)
        {
            vm.letter=letter;
            for (var i = 0; i < jQuery('.autor').length; i++) {
                var nom ='';
                //var nom = jQuery('.autor').eq(i).find('.info').find('.nombre').text().trim();
                if(vm.orderAutor =='data.slug')
                    nom = jQuery('.autor').eq(i).attr('data-slug');
                else
                    nom = jQuery('.autor').eq(i).attr('data-cslug');


                //cognom_slug
                if(vm.firstItem(nom) == letter)
                {
                    jQuery('.autores').scrollTop(0);
                    jQuery('.autores').scrollTop(jQuery('.autor').eq(i).offset().top-jQuery('.autores').offset().top);
                    break;
                }
            }
        };

        vm.perParaules = function(s)
        {
            
            var es =[];
            if(s.length > 2)
            {
                /*for (var i = 0; i < vm.espais.data.length; i++) {
                    if(vm.espais.data[i].data.nom_ca.indexOf(s)!==-1)
                    {
                        es.push(vm.espais.data[i]);
                    }
                }
                console.log(es);
                */
               
               autorService.closeAllInMenu();
               cfpLoadingBar.start();
               espaiService.getSearch(s,vm.territori).then(function(data)
               {
                    cfpLoadingBar.set(0.7);
                    espaiService.isSearch = true;
                    if(!data.info.text.length)
                    {
                        vm.modal.show("CERCA", "No s'ha trobat cap resultat.");
                    }
                    for (var i = 0; i < data.info.text.length; i++) {
                  //      console.log(data.info.text[i].espai);
                        if(data.espais.length)
                        {
                            var valid = function(id)
                            {
                                for (var i = 0; i < data.espais.length; i++) 
                                    if(data.espais[i].id==id)
                                        return true;

                                return false;
                            }
                            var b = valid(data.info.text[i].espai);
                            if(b){
                                console.log("localed");
                                var espai = espaiService.getEspaiByID(data.info.text[i].espai);
                        espai.search = true;
                        es.push(espai);
                        if(espai.data.ambit==4)
                            autorService.openInMenu(espai.data.autor,"centre",null,true);
                        else{
                            if(!espai.ruta.length)
                                autorService.openInMenu(espai.data.autor,"espais",null,true);
                            else{
                                autorService.openInMenu(espai.data.autor,"rutas", autorService.getSlugify( rutaService.getRutaData(espai.id).data.nom_ca ),true );
                            }

                        }
                            }

                        }
                        else{
                            var espai = espaiService.getEspaiByID(data.info.text[i].espai);
                            espai.search = true;
                            es.push(espai);
                            if(espai.data.ambit==4)
                                autorService.openInMenu(espai.data.autor,"centre",null,true);
                            else{
                                if(!espai.ruta.length)
                                    autorService.openInMenu(espai.data.autor,"espais",null,true);
                                else{
                                    autorService.openInMenu(espai.data.autor,"rutas", autorService.getSlugify( rutaService.getRutaData(espai.id).data.nom_ca ),true );
                                }

                            }    
                        }
                    }
                    console.log(es);
                    //mapsService.centerMapEspais(es);
                    cfpLoadingBar.complete();
               },function()
               {
                cfpLoadingBar.complete();
                vm.modal.show("CERCA", "No s'ha trobat cap resultat.");
               });


            }else
            {
                vm.modal.show("CERCA", "La paraula ha de tenir com a mínim tres lletres.");
            }
        };
        
        

        vm.activeSlug = function(s)
        {
            return ($location.url() == '/'+language+s);
        };
        /**
        * @ngdoc method
        * @name activeItemMenu
        * @memberof AppController
        * @desciption
        * Activa un punto de menu 
        */
        vm.activeItemMenu = function(url)
        {
            var b = false;
            if(url=="/"+vm.language || url=="/")
            {
                if($location.url().indexOf('/espai') !== -1)
                    b = true;
                if($location.url().indexOf('/centre') !== -1)
                    b = true;
                if($location.url().indexOf('/autor') !== -1)
                    b = true;

            }

            if(url == $location.url())
                b = true;
            return b;
        };

        vm.activeLetter = function(letter)
        {
            for (var i = 0; i < vm.autors.length; i++) {
                
                if(vm.autors[i].data.cognom_slug.toLowerCase()[0] == letter && vm.autors[i].visible)
                {
                    return true;
                }
            }
            return false;
        };

    	/**
        * @ngdoc method
        * @name sayHello
        * @memberof AppController
        * @desciption
        * Dice Hola
        */
        vm.sayHello = function()
        {
        	debugService.log("sayHello");
        };
        /**
         * c
        * @ngdoc method
        * @name begin
        * @memberof AppController
        * @desciption
        * Comienza
        */
        vm.begin = vm.mapa.begin = function()
        {
            if(!mapsService.benvinguts)
                return;
            mapsService.benvinguts = false;
            espaiService.isSearch = false;

            $timeout(function(){

                jQuery( ".autores" ).eq(0).scroll(function() {


                    for (var i = 0; i < jQuery('.autor').length; i++) {
                        var autortop = jQuery('.autor').eq(i).offset().top-jQuery('.autores').offset().top-jQuery('.ordenar').height();

                        if( autortop > 10){

                            var nom ='';
                            //var nom = jQuery('.autor').eq(i).find('.info').find('.nombre').text().trim();
                            if(vm.orderAutor =='data.slug')
                                nom = jQuery('.autor').eq(i).attr('data-slug');
                            else
                                nom = jQuery('.autor').eq(i).attr('data-cslug');

                            console.log( jQuery('.alfabeto').find('li').length );

                            var lis = jQuery('.alfabeto').find('li').length;
                            for (var j = 0; j < lis; j++) 
                            {
                                
                                if(vm.firstItem(nom) == jQuery('.alfabeto').find('li').eq(j).text())
                                {
                                    jQuery('.alfabeto').find('li').removeClass("active");
                                    jQuery('.alfabeto').find('li').eq(j).addClass("active");
                                    break;
                                }
                            }
                            /*$timeout(function(){
                                vm.letter = vm.firstItem(nom);    
                            });*/                            
                            break;
                        }
                    } 

                });

            });
            
        };
        
        /**
        * @ngdoc method
        * @name getMediaUrl
        * @memberof AppController
        * @desciption
        * Devuelve una imagen con la carpeta media.
        */
        vm.getMediaUrl = function(p)
        {
            return '/media/'+p;
        };
        /**
        * @ngdoc method
        * @name getEspais
        * @memberof AppController
        * @desciption
        * Devuelve todos los espais escrits.
        */
        vm.getEspais = function()
        {
            return espaiService.getEspais();
        };

        vm.setLanguage  = function(l)
        {
            
            if(vm.espais.lang!=l)
            {
                vm.espais.setLanguage(l);
                mapsService.reset();

                vm.init();
            }
        };

        /**
        * @ngdoc method
        * @name init
        * @memberof AppController
        * @desciption
        * Inicia la aplicación
        */
        vm.init = vm.espais.init = function()
        {
            //vm.espais.experiencies=true;
            cfpLoadingBar.start();
            vm.modal.close();
            vm.letter='a';
            vm.paraules ="";
            vm.territori ="";
            vm.mapa.eventPan = true;
            espaiService.isSearch = false;
            return autorService.getAutors().then(function(data)
            {
                cfpLoadingBar.inc();
                vm.autors = data;
                console.log(data);
                autorService.closeAllInMenu();
                console.log("AUTOR FINISH");
                return vm.getEspais().then(function(espais)
                    {
                        cfpLoadingBar.inc();

                       autorService.invisibleContent(espais);
                       console.log("Espais FINISH");
                       mapsService.addMarkers();
                       console.log("Espais FINISH 2");
                       return rutaService.getRutas().then(function(rutas)
                        {
                            cfpLoadingBar.inc();
                            mapsService.loadedMap=true;

                            for (var i = 0; i < rutas.length; i++){
                            
                                mapsService.Polyline(rutas[i],rutas[i].data.autor);
                            }
                            console.log("Polyline FINISH");
                            
                            //$rootScope.$broadcast('onMarkersLoad');
                       
                            //$rootScope.$broadcast('onPoligonsLoad');
                            cfpLoadingBar.complete();
                            return true;
                        });
                       

                    });
            });
        };

        vm.resolve = vm.espais.resolve = function()
        {
            //vm.espais.experiencies=true;
            return autorService.getAutors().then(function(data)
            {
                return vm.getEspais().then(function(data)
                    {
                       return rutaService.getRutas().then(function(data)
                        {

                            return true;
                        });
                       

                    });
            });
        };

        vm.aplicarFiltresRutes = function(ruta)
        {
            autorService.invisibleAll();
            for (var i = 0; i < ruta.espais.length; i++) {
                var espai = espaiService.getEspaiByID( ruta.espais[i].espai_id );
                console.log(espaiService.getEspaiByID( ruta.espais[i].espai_id ));
                if(espai){
                    var autor = espai.data.autor;
                    autorService.setVisible(autor,true);
                }
            }
            
            //autorService.setVisible(autor,true);
            //espais.getEspaiByID(ruta.espais[0].espai_id)
            vm.aplicarFiltres( ruta.id );
            vm.openFilt = false;
        };

        vm.aplicarFiltres = function(ruta)
        {
            if(autorService.isInVisibleAll()){
                autorService.visibleAll()
            }
            mapsService.eventPan = false;
            mapsService.setMapOnAll(ruta);
            vm.openFilt = false;
            //Agregar poligonos
        };
        $scope.$watch("mapa.gmaps",function(newValue,oldValue) {
        if(newValue)
            $timeout(function()
                {
                    vm.init();
                    console.log("INIT APP");
                });
        });
       
        
        
        $scope.$on("onRutaLoaded", function(event, data)
        {
               console.log("rutaa LOADED")
              vm.mobileTab = true;
        });
        
        if( url.replace(domain,'').length > 4)
        {
            vm.mapa.benvinguts=false;
            vm.begin();
        }
        
    }
})();